import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { transformListClusterHPAsResponse, computeHpaSummary } from '../_utils';

const CLUSTER_HPAS_QUERY_KEY = 'cluster-hpas';

const getClusterHpasQueryKey = (params: { clusterId?: string } = {}) => {
  if (params.clusterId) {
    return [CLUSTER_HPAS_QUERY_KEY, params.clusterId] as const;
  }
  return [CLUSTER_HPAS_QUERY_KEY] as const;
};

const getClusterHpasQueryOptions = ({
  clusterId,
  enabled = true,
}: {
  clusterId?: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getClusterHpasQueryKey({ clusterId }),
    queryFn: async () => {
      const { data } = await apiClient.workloadOptimization.listClusterHPAs({
        clusterId: clusterId!,
        includeConversion: 'AVERAGE_VALUE_FROM_ORIGINAL_REQUESTS',
      });
      const rows = transformListClusterHPAsResponse(data.items ?? []);
      return { rows, summary: computeHpaSummary(rows) };
    },
    enabled: enabled && !!clusterId,
  });

export const useClusterHpasQuery = ({
  clusterId,
  enabled,
}: {
  clusterId?: string;
  enabled?: boolean;
}) => {
  const { isLoading, data, error, refetch } = useQuery(
    getClusterHpasQueryOptions({ clusterId, enabled })
  );

  return {
    isLoading,
    error,
    refetch,
    rows: data?.rows ?? [],
    summary: data?.summary,
  };
};
